import React from 'react';
import '../stalk-market/index.css';
import StalkMarketApp from '../stalk-market/App';

const Project1 = () => {
  return <StalkMarketApp />;
};

export default Project1; 